import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Download } from 'lucide-react';
import { labReports, clinicalSurvey } from '../mock';
import { toast } from 'sonner';

const TransparencyPage = () => {
  const handleDownload = (reportTitle, downloadUrl) => {
    toast.info(`Downloading: ${reportTitle}`, {
      description: 'Your download will begin shortly.',
      duration: 3000,
    });
    window.open(downloadUrl, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Transparency Reports & Lab Testing | Naru Tofu</title>
        <meta name="description" content="View Naru Tofu's NABL-certified lab reports. We publish all quality testing results - nutritional analysis, water quality, shelf life studies." />
        <link rel="canonical" href="https://narutofu.com/transparency" />
      </Helmet>
      <div style={{ minHeight: '100vh' }}>
      {/* Lab Reports Section */}
      <section id="reports" className="reports-section section-padding">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h1 className="hero-large" style={{ marginBottom: '16px' }}>Transparency through Testing</h1>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              See how our tofu exceeds industry standards
            </p>
          </div>
          
          <div className="reports-grid">
            {labReports.map((report) => (
              <div key={report.id} className="report-card hover-lift">
                <div className="report-header">
                  <h3 className="heading-2">{report.title}</h3>
                  <p className="body-small" style={{ color: 'var(--text-secondary)', marginTop: '8px' }}>
                    {report.lab} • {report.date}
                  </p>
                </div>
                
                <div className="report-highlights">
                  {report.highlights.map((highlight, idx) => (
                    <div key={highlight.metric} className="highlight-item">
                      <div className="highlight-metric">
                        <span className="body-small" style={{ color: 'var(--text-secondary)' }}>
                          {highlight.metric}
                        </span>
                      </div>
                      <div className="highlight-comparison">
                        <div className="comparison-item">
                          <span className="body-small" style={{ fontWeight: '600' }}>Naru Tofu</span>
                          <span className="body-regular" style={{ color: highlight.better ? 'var(--status-success)' : 'var(--text-primary)' }}>
                            {highlight.naruValue}
                          </span>
                        </div>
                        <div className="comparison-item">
                          <span className="body-small" style={{ fontWeight: '600' }}>Industry Standard</span>
                          <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                            {highlight.industryStandard}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                
                <button 
                  className="btn-icon"
                  onClick={() => handleDownload(report.title, report.downloadUrl)}
                >
                  <Download size={16} />
                  Download full report
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clinical Survey Section */}
      <section id="clinical" className="clinical-section section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container">
          <div className="grid-two-column">
            <div>
              <h2 className="hero-medium" style={{ marginBottom: '24px' }}>{clinicalSurvey.title}</h2>
              <div className="survey-meta">
                <p className="body-regular" style={{ marginBottom: '8px' }}>
                  <strong>Partner:</strong> {clinicalSurvey.partner}
                </p>
                <p className="body-regular" style={{ marginBottom: '8px' }}>
                  <strong>Duration:</strong> {clinicalSurvey.duration}
                </p>
                <p className="body-regular">
                  <strong>Participants:</strong> {clinicalSurvey.participants}
                </p>
              </div>
            </div>
            
            <div className="survey-stats">
              {clinicalSurvey.keyFindings.map((finding, index) => (
                <div key={finding.statistic} className="stat-item">
                  <span className="stat-number">{finding.statistic}</span>
                  <p className="body-small" style={{ color: 'var(--text-secondary)' }}>{finding.description}</p>
                </div>
              ))}
            </div>
          </div>
          
          <div className="doctor-quote">
            <p className="body-large" style={{ fontStyle: 'italic', marginBottom: '16px' }}>
              "{clinicalSurvey.doctorQuote}"
            </p>
            <div>
              <p className="body-regular" style={{ fontWeight: '600' }}>{clinicalSurvey.doctorName}</p>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>{clinicalSurvey.doctorTitle}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default TransparencyPage;
